class DynamicLinkFormElementController {
  constructor() {

  }
}

export default DynamicLinkFormElementController;
